export const AnnotationControls = () => {
  // TODO: Implement annotation controls
  return <></>;
};
